module.exports = __webpack_public_path__ + "static/img/rmm_bg_1.5046b63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rmm_bg_1.jpg
// module id = WLDl
// module chunks = 1